/**
 * Checks whether the given source string begins with an XML declaration/prolog.
 *
 * @param source  the raw response body
 * @returns       true if it starts with "<?xml", false otherwise
 */
export function hasXmlDeclaration(source: string): boolean {
    return source.trim().startsWith('<?xml');
}